import request from '../utils/request';

// 获取聊天会话列表
export const getChatSessions = () => {
  return request({
    url: '/api/manage/chat/sessions',
    method: 'get'
  });
};

// 获取历史消息记录
export const getChatMessages = (params) => {
  return request({
    url: '/api/manage/chat/messages',
    method: 'get',
    params
  });
};

// 发送消息
export const sendMessage = (userId, data) => {
  return request({
    url: '/api/manage/chat/send',
    method: 'post',
    params: { userId },
    data
  });
};

// 标记会话为已读
export const markSessionAsRead = (sessionId) => {
  return request({
    url: '/api/manage/chat/read',
    method: 'post',
    params: { sessionId }
  });
};
